'use clinet'

import { createContext, ReactNode, useContext, useState } from "react"

export const HistoryContext = createContext<{
    historyTab: any[]
    SetHistoryTab: Function
}>({
    historyTab: [],
    SetHistoryTab: ()=> {}
})

export default function HistoryProvider({ children }: { children: ReactNode }) {
    const [historyTab, setHistoryTab] = useState<any[]>([])
    function SetHistoryTab(tabs: any[]){
        setHistoryTab(tabs)
    }
    return (
        <HistoryContext.Provider value={{historyTab, SetHistoryTab}}>
            {children}
        </HistoryContext.Provider>
    )
}

export const useHistory = ()=> useContext(HistoryContext)